/**
 * Mobile menu management module
 * Handles hamburger menu toggle and state management
 */

/**
 * Hamburger icon SVG path
 */
export const HAMBURGER_ICON =
  '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>';

/**
 * Close (X) icon SVG path
 */
export const CLOSE_ICON =
  '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>';

/**
 * Toggles the mobile menu open/closed state
 * @param {HTMLElement} btn - The menu button element
 * @param {HTMLElement} menu - The mobile menu element
 * @returns {boolean} True if menu is now open, false if closed
 */
export function toggleMobileMenu(btn, menu) {
  if (!btn || !menu) return false;
  const isOpen = menu.classList.toggle('hidden');
  btn.setAttribute('aria-expanded', String(!isOpen));
  const svg = btn.querySelector('svg');
  if (svg) {
    svg.innerHTML = isOpen ? HAMBURGER_ICON : CLOSE_ICON;
  }
  return !isOpen;
}

/**
 * Closes the mobile menu
 * @param {HTMLElement} btn - The menu button element
 * @param {HTMLElement} menu - The mobile menu element
 */
export function closeMobileMenu(btn, menu) {
  if (!btn || !menu) return;
  menu.classList.add('hidden');
  btn.setAttribute('aria-expanded', 'false');
  const svg = btn.querySelector('svg');
  if (svg) {
    svg.innerHTML = HAMBURGER_ICON;
  }
}

/**
 * Opens the mobile menu
 * @param {HTMLElement} btn - The menu button element
 * @param {HTMLElement} menu - The mobile menu element
 */
export function openMobileMenu(btn, menu) {
  if (!btn || !menu) return;
  menu.classList.remove('hidden');
  btn.setAttribute('aria-expanded', 'true');
  const svg = btn.querySelector('svg');
  if (svg) {
    svg.innerHTML = CLOSE_ICON;
  }
}

/**
 * Checks if the mobile menu is currently open
 * @param {HTMLElement} menu - The mobile menu element
 * @returns {boolean} True if open, false if closed
 */
export function isMobileMenuOpen(menu) {
  if (!menu) return false;
  return !menu.classList.contains('hidden');
}
